
import { error } from 'jquery';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from 'src/app/services/loader.service';
import Swal from 'sweetalert2';
import { api } from '../URL/api-url';

@Component({
  selector: 'app-pages-login-with-token-component',
  templateUrl: './pages-login-with-token-component.component.html',
  styleUrls: ['./pages-login-with-token-component.component.css']
})
export class PagesLoginWithTokenComponent implements OnInit {
  token: any
  url:any;
  constructor(public _LoaderService: LoaderService, private router: ActivatedRoute, private route: Router) { }

  async ngOnInit(): Promise<void> {


    this.router.queryParams.subscribe(params => {
      this.token = params['token'];
      this.url = params['url'];
    });
    await this.getAdminDetails()
  }
  async getAdminDetails() {

    var endPoint = "login-member-details";
    var payload = {
      token: this.token,

       url:this.url
    }
    try {
      const response: any = await fetch(api.commonLoginApiUrl + endPoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify(payload)
      });
      console.log(response, error)

      if (!response.ok) {
        let error = await response.json()
        console.log(error)
        throw new Error(error.error.message || error.error);
      }
      const { data, profiles } = await response.json();
      console.log(data, "data1889")

       sessionStorage.setItem('login', 'true');
        sessionStorage.setItem('loginTime', data.lastLogin);
        sessionStorage.setItem('accessToken', data.token);
        sessionStorage.setItem('customerId', data.customerId);
        sessionStorage.setItem('customerName', data.userName);
        sessionStorage.setItem('coproratelogo', data.corporateLogo);
        sessionStorage.setItem("customerId", data.customerId);
      if (data && data?.settings && data?.settings?.length > 0) {
          sessionStorage.setItem("fileSize", data?.settings[0]?.settingsValue);
        }
        this.route.navigate(['home']);
    } catch (error) {


      Swal.fire({allowOutsideClick: false,
        title: 'Alert',
        text: 'Info',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Proceed',
      }).then((result) => {

        if (result.isConfirmed) {


          sessionStorage.clear()
          this.route.navigate(['/login']);

        }
        else {
          sessionStorage.clear();
          this.route.navigate(['/login']);


        }
      });

    }
  }

}
